// extracted by mini-css-extract-plugin
module.exports = {"blog_hero_simple":"top_section_blog_hero_simple__qcd7C","wrapper":"top_section_wrapper__t98kH","tag_btn":"top_section_tag_btn__lLkrj","title":"top_section_title__Ybu2J"};